/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { typedDependencies } from './dependenciesTyped.generated';
import { createIsInteger } from '../../factoriesAny.js';
export var isIntegerDependencies = {
  typedDependencies: typedDependencies,
  createIsInteger: createIsInteger
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/es/entry/dependenciesAny/dependenciesIsInteger.generated.js
// module id = 76
// module chunks = 0